import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import Icon from 'assets/components/icon/Icon';
import CheckInput from 'assets/components/inputs/check/CheckInput';
import DateInput from 'assets/components/inputs/dateInput/DateInput';
import { inputStyles } from 'assets/components/inputs/Input';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import Theme from 'assets/themes/Theme.Common';
import { defaultInputDateTimeFormat } from 'assets/utils/data/Date';
import RefundPaymentType from 'models/enums/RefundPaymentType';
import { useContractRefundPaymentProvider } from '../Finance.ContractRefundPayment.Hooks';

export default function ContractRefundPaymentFilters() {
  const { lang, translate } = getLocales();
  const { listApi, dealersApi, distributorsApi, userApi, pageRouter } = useContractRefundPaymentProvider();
  const { isDealer } = useAuthStore();

  return (
    <FilterForm
      subcomponents={ThemeFilterFormDrawer}
      search={listApi.body?.search}
      onSearch={(search) => listApi.execute((body) => ({ ...body, search, offset: 0 }))}
      filters={listApi?.body}
      onFilter={(newFilters) => {
        listApi?.execute({ ...newFilters, offset: 0 });
      }}
      onReset={() => {
        pageRouter.redirect(
          { ...pageRouter.params },
          {
            ...pageRouter.query,
            list: undefined,
          }
        );
      }}
      onOpen={() => {
        if (!userApi?.payload) userApi?.execute();
        if (!dealersApi?.payload) dealersApi?.execute((b) => b);
        if (!distributorsApi?.payload) distributorsApi?.execute((b) => b);
      }}
      render={({ tempFilters, setFilters }) => (
        <>
          <TextInput
            name="payeeName"
            label={lang.payeeName}
            value={tempFilters?.payeeName}
            onChange={setFilters}
            icon={<Icon class="if-quill-pen" />}
          />
          <SelectInput
            name="paymentMethodCode"
            label={lang.paymentMethod}
            data={Object.values(RefundPaymentType).map((it) => ({
              id: it,
              title: translate(it),
            }))}
            isMultiselect
            value={tempFilters?.paymentMethodCode}
            onChange={setFilters}
          />
          <SelectInput
            name="dealerId"
            label={lang.dealers}
            data={dealersApi?.payload?.data?.map((item) => ({
              ...item.displayInfo,
              icon: <Icon class="fas-user-friends" />,
            }))}
            isMultiselect
            value={tempFilters?.dealerId}
            onChange={setFilters}
            disabled={isDealer}
            icon={<Icon class="fas-user-friends" />}
          />
          <SelectInput
            name="distributorId"
            label={lang.distributors}
            data={distributorsApi?.payload?.data?.map((item) => ({
              ...item.displayInfo,
              icon: <Icon class="fas-globe" />,
            }))}
            isMultiselect
            value={tempFilters?.distributorId}
            onChange={setFilters}
            icon={<Icon class="fas-globe" />}
          />
          <SelectInput
            name="ownerId"
            label={lang.owner}
            data={userApi?.payload?.data?.map((item) => ({
              ...item.displayInfo,
              icon: <Icon class="fas-user" />,
            }))}
            isMultiselect
            value={tempFilters?.ownerId}
            onChange={setFilters}
            icon={<Icon class="fas-user" />}
          />
          <DateInput
            name="createdAtLocalFrom"
            label={lang.startDate}
            dateTimeFormat={defaultInputDateTimeFormat}
            value={tempFilters?.createdAtLocalFrom}
            onChange={setFilters}
            icon={<Icon class="fas-calendar-alt" />}
          />
          <DateInput
            name="createdAtLocalTo"
            label={lang.endDate}
            dateTimeFormat={defaultInputDateTimeFormat}
            value={tempFilters?.createdAtLocalTo}
            onChange={setFilters}
            icon={<Icon class="fas-calendar-alt" />}
          />
          <DateInput
            name="paymentDateFrom"
            label={lang.paymentAt + ' ' + lang.startDate}
            dateTimeFormat={defaultInputDateTimeFormat}
            value={tempFilters?.paymentDateFrom}
            onChange={setFilters}
            icon={<Icon class="fas-calendar-alt" />}
          />
          <DateInput
            name="paymentDateTo"
            label={lang.paymentAt + ' ' + lang.endDate}
            dateTimeFormat={defaultInputDateTimeFormat}
            value={tempFilters?.paymentDateTo}
            onChange={setFilters}
            icon={<Icon class="fas-calendar-alt" />}
          />
          <CheckInput
            name="isCancelled"
            label={lang.show + ' ' + lang.cancelled}
            class={inputStyles.check.switch + ' formInput'}
            style={{ marginTop: Theme.Size.M, alignSelf: 'center' }}
          value={tempFilters?.isCancelled}
            onChange={({ isCancelled }) =>
              setFilters({
                ...tempFilters,
                isCancelled: Boolean(isCancelled),
              })
            }
            htmlElementProps={{ title: tempFilters.isCancelled ? lang.disable : lang.enable }}
          />
        </>
      )}
    />
  );
}
